export const assignmentLabel = (agent, group, currentUserId) => {
  const agentName = agent?.id === currentUserId ? 'You' : agent?.name
  const groupName = group?.name

  return [groupName, agentName].filter(n => n).join(': ') || null
}
